import firebase from "firebase/compat/app"; //v9
import "firebase/compat/firestore";
const app = firebase.initializeApp({
  apiKey: "AIzaSyANBNhNV3zG-jrVjA6URsRB67eMO6gO9ng",
  authDomain: "zerko-gg.firebaseapp.com",
  projectId: "zerko-gg",
  storageBucket: "zerko-gg.appspot.com",
  messagingSenderId: "38520689458",
  appId: "1:38520689458:web:c4ef538c28aadb7d73fd2b",
  measurementId: "G-0CKC2EZNB1",
});

//firestore

const firestore = app.firestore();

export const db = {
  members: firestore.collection("member"),
  winners: firestore.collection("winners"),
};
export default app;
